import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "user",
  listKey: "users",
  itemKey: "user",
  getAll: types.GET_ALL_USERS,
  getAllResponse: types.GET_ALL_USERS_RESPONSE,
  getByIdResponse: types.GET_USER_BY_ID_RESPONSE,
});
